export const API_KEY_ACTIONS = {
  CLEAR_GENERATED_KEY: 'apiKeys/clearGeneratedKey',
  FETCH_LIST: 'apiKeys/fetchList',
  FETCH_SCOPES: 'apiKeys/fetchScopes',
};

export const EMAIL_CENTER_ACTIONS = {
  FETCH_TEMPLATES: 'emailCenter/fetchTemplates',
  FETCH_TEMPLATE_TYPES: 'emailCenter/fetchTemplateTypes',
  FETCH_VARIABLES: 'emailCenter/fetchVariables',
  FETCH_JOURNEY_EMAIL_CONFIG: 'emailCenter/fetchJourneyEmailConfig',
  FETCH_JOURNEY_THEME: 'emailCenter/fetchJourneyTheme',
  // Reducer, not an effect: writes a theme the caller already persisted
  // into the store, so previews restyle without a refetch.
  SET_JOURNEY_THEME: 'emailCenter/saveJourneyTheme',
  FETCH_JOURNEY_TEMPLATES: 'emailCenter/fetchJourneyTemplates',
  FETCH_AUTOMATIONS: 'emailCenter/fetchAutomations',
  FETCH_MAILERS: 'emailCenter/fetchMailers',
  FETCH_TRANSLATIONS: 'emailCenter/fetchTranslations',
  SAVE_TRANSLATION: 'emailCenter/saveTranslation',
  FETCH_FRAGMENTS: 'emailCenter/fetchFragments',
  FETCH_EMAIL_SETTINGS: 'emailCenter/fetchEmailSettings',
  FETCH_PARTNER_LANGUAGES: 'emailCenter/fetchPartnerLanguages',
  SAVE_EMAIL_SETTINGS: 'emailCenter/saveEmailSettings',
  SELECT_JOURNEY: 'emailCenter/setSelectedJourney',
  OPEN_DRAWER: 'emailCenter/openDrawer',
  CLOSE_DRAWER: 'emailCenter/closeDrawer',
  PATCH_DRAWER_RECORD: 'emailCenter/patchDrawerRecord',
};
